window.addEventListener("load", (event) => {
    $('body').on('click', '#per-page-menu .dropdown-item', function (e) {
        let perPage = $(this).data('per-page');

        let date = new Date;
        date.setDate(date.getDate() + 365);
        setCookie('per_page', perPage, {path: '/', expires: date.toUTCString()});
        $('#products_loader').fadeIn(300);
        $('#products-container').fadeOut(300);
        /*$('#category-main-content').load(window.location.href + ' #category-main-content-inner', function () {
            lazy();
            $('#products_loader').fadeOut(300);
            $('#products-container').fadeIn(300);
        });*/
    });

    $('body').on('click', '.btn-control' , function (){
        let gridType = $(this).data('ls');
        setCookie('gridType', gridType);
    });

    let pricesArray = $('#minMax').val().split(',').map(Number);
    let fromTo = $('#fromTo').val().split(',').map(Number);
    let from = fromTo[0];
    let degree = from.toString().length - 1;
    let d = 10 ** degree;
    from =  Math.floor(from/d)*d;
    let to = fromTo[fromTo.length -1];
    degree = to.toString().length - 1;
    d = 10 ** degree;
    to =  Math.floor(to/d)*d;

    let $rangePrices = $(".priceFilter");

    if (pricesArray.length > 0) {
        pricesArray.forEach(function(e, i) {
            if(i === 0 && e >= from) from = i;
            else if(pricesArray[i] >= from && pricesArray[i - 1] <= from) from = i;
            if(i === (pricesArray.length - 1) && e <= to) to = i;
            else if(e <= from && pricesArray[i - 1] >= to) to = i+1;
            if(e === to) to = i+1;
        })
        const config = {
            min: pricesArray[0],
            max: pricesArray[pricesArray.length - 1],
            from: from,
            to: to,
            skin: "big",
            type: "double",
            grid: true,
            values: pricesArray,
        }

        $rangePrices.ionRangeSlider(config);
    } else {
        $rangePrices.ionRangeSlider({
            skin: "big",
            min:pricesArray[0],
            max:pricesArray[0],
            hide_min_max: true
        });
    }

    $('.dropdown-toggle').dropdown();

    setTimeout(function () {
        $('.mySwiperDesktop').css('visibility', 'visible');
    }, 1);
})